import "./caseStudyStyles.css";
import brush from "./brush.svg";
import piece8 from "./front.png";
import piece17 from "./affinity.png";
import piece20 from "./Seller_Dashboard.png";
import piece21 from "./Content_Hub.png";
import piece22 from "./Content_Hub2.png";
import piece23 from "./setting1.png";
import piece24 from "./setting2.png";
import piece25 from "./BuyerDashboard.png";
import piece26 from "./ee_m.gif";
import piece27 from "./team.png";
import piece28 from "./webinar.png";
import emailicon from "./email-icon.svg";
import hands from "./user.svg";
import share from "./share.svg";
import star from "./star.svg";
import animationData from "./Scene.mp4";
import Header from "./Header";

export default function CaseStudy() {
  return (
    <div class="case-study-page" style={{ paddingTop: "56px" }}>
      <Header />
      {/* <!-- HERO --> */}
      <section class="hero-section">
        <div class="hero-inner">
          <div class="hero-top">
            <div class="hero-icon">
              <img src={brush} alt="" style={{ color: "white" }} />
            </div>

            <div class="hero-badge">
              <span>SHIPPED</span>
            </div>
          </div>

          <div class="hero-content">
            <h2 style={{ fontSize: "40px" }}>LeadrPro Product Research & Rebrand</h2>

            <p class="hero-subtitle">Reduced user friction and improved feature discoverability</p>

            <p class="hero-description">
              I led the brand redesign of LeadrPro – a B2B solution that aims at reinventing the Saas marketplace and change the world of sofware
              discovery. LeadrPro gives C-suite level users the opportunity to directly connect with interested buyers looking for B2B solutions.
            </p>
            {/* 
            <div class="hero-actions">
              <a href="/">
                Google Blog
                <span>↗</span>
              </a>
            </div> */}
          </div>
          <div class="hero-preview">
            <div class="preview-frame">
              <video autoPlay loop muted playsInline>
                <source src={animationData} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- PROJECT META --> */}
      <section class="project-meta">
        <div class="meta-grid">
          <div class="meta-item">
            <span class="meta-label">Product</span>
            <p>Desktop</p>
            <p>Mobile</p>
          </div>

          <div class="meta-item">
            <span class="meta-label">My role</span>
            <p>Product Research & Designer</p>
          </div>

          <div class="meta-item">
            <span class="meta-label">Timeline</span>
            <p>Jan 2024 - Dec 2024</p>
          </div>

          <div class="meta-item">
            <span class="meta-label">Skills</span>
            <p>Product design, Market Research, Interactive prototyping, User research, Competitor Analysis</p>
          </div>
        </div>

        <div class="team-row">
          <span class="meta-label">Team</span>

          <p>Walter Guavara, Chris Sheng, Ryan Costanza, Jiaqi Yang</p>
        </div>
      </section>

      {/* <!-- QUOTE IMAGE --> */}
      <section class="quote-banner">
        <div class="quote-image">
          <img src={piece17} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />

          {/* <div class="quote-overlay">
            <h2>
              "Handing someone your phone
              <br />
              feel like handing over your whole diary..."
            </h2>
          </div> */}
        </div>
      </section>

      {/* <!-- PROBLEM --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Problem: Unclear Value Proposition</h2>
        </div>

        <div class="section-content">
          <p>
            The LeadrPro website functions as a crucial marketing tool for their business and selling vendors, but the current user experience is
            unclear, making it difficult for <b>(33%)</b> of users to understand the company's offerings.
          </p>

          <p>
            At the time of writing, LeadrPro is frontrunner in revolutionizing this B2B service marketplace but lacks integrity and the trust from new
            users.
          </p>

          <p>
            This lack of clarity hinders user engagement, and difficulty in engaging users on the website leads to low retention, high user friction
            and trust issues in the legitimacy of this product.
          </p>
        </div>
      </section>

      {/* <!-- RESEARCH --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Research</h2>
        </div>

        <div class="section-content">
          <p style={{ margin: "0" }}>
            In the early stages of the redesign, we interviewed and surveyed over 75 participants to understand their use-cases and struggles.
          </p>

          <div class="research-points">
            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)",}}>Lacks visual differentiation and informational hierarchy</h3>

              <p>More than 40% of answers directly pointed to poor website user flow inflicting high user friction.</p>
            </div>

            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)",}}>Platform fails to bridge buyer interest with seller products</h3>

              <p>
                Buyers consistently admitted to bypassing product content, revealing the platform fails to create meaningful touchpoints between
                buyers and the products they are demoing. While more than <b>(70%)</b> of sellers raised concerns that the platform did not deliver on
                B2B buyer leads (no buyer demos) that it promised.
              </p>
            </div>

            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)",}}>Credibility with new users</h3>

              <p>
                Over a third of outside forums expressed skepticism about the platform's legitimacy, citing a lack of social proof, unclear messaging,
                and no visible trust signals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- SOLUTION --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Solution: Redesigning Trust, Clarity, and Connection</h2>
        </div>

        <div class="section-content">
          <p>
            It became clear that B2B software sellers joined the platform to receive hundreds of customer leds to avoid the regular hassle of cold
            emailing and customary lead generation strategies — A feature that the LeadrPro platform promises but did not actively deliver.
          </p>

          <p>
            Transforming a confusing marketplace into a platform where C-suite buyers discover relevant B2B solutions and sellers gain access to a
            clear dashboard with hundreds of qualified leads.
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h3 style={{ marginTop: "30px" }}>Proposed solutions</h3>
            <div class="feature-grid">
              <div class="feature-card">
                {/* <div class="feature-icon">
                  <img src={emailicon} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />
                </div> */}

                <p>Redesigned Information Architecture</p>
              </div>

              <div class="feature-card">
                {/* <div class="feature-icon">
                  <img src={emailicon} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />
                </div> */}

                <p>Personalized Buyer Dashboard</p>
              </div>

              <div class="feature-card">
                {/* <div class="feature-icon">
                  <img src={emailicon} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />
                </div> */}

                <p>Seller Lead Management System </p>
              </div>

              <div class="feature-card">
                {/* <div class="feature-icon">
                  <img src={emailicon} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />
                </div> */}

                <p>Trust & Social Proof Signals</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- FEATURE BLOCKS --> */}
      <section class="feature-sections">
        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={emailicon} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />
            </div>

            <h3>Simplifying the onboarding flow.</h3>
          </div>

          <div class="feature-copy">
            <p>Restructuring the navigation required stripping back layers of unclear messaging to surface LeadrPro's core value proposition</p>

            <p>
              From the beginning, the goal was to get users to understand the platform in seconds, not minutes. Reducing cognitive load at every step
              so both buyers and sellers could find their footing without friction.
            </p>
          </div>
        </div>

        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={hands} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain", height: "22px" }} />
            </div>

            <h3>Bridging the intent gap between buyers and sellers.</h3>
          </div>

          <div class="feature-copy">
            <p>
              One of the most revealing findings from our research was that buyers weren't coming to LeadrPro to discover new software, but to simply
              take advantage of the buyer compensation per completed demo
            </p>

            <p>
              The design challenge wasn't just aesthetic, it was behavioral. We needed to create natural product touchpoints throughout the buyer
              journey that sparked genuine curiosity without feeling like forced advertising. The solution required rethinking how product information
              was surfaced, making it feel like a benefit to the buyer rather than an obligation while hitting the right audience.
            </p>
          </div>
        </div>

        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={share} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain", height: "23px" }} />
            </div>

            <h3>Surfacing the right leads at the right time.</h3>
          </div>

          <div class="feature-copy">
            <p>
              Sellers joined LeadrPro with the unique expectation of having access to hundreds of qualified leads without the grind of cold outreach
              and traditional lead generation. The existing platform promised this, but failed to actively deliver it in a way that was actionable or
              organized.
            </p>

            <p>
              This meant designing a pipeline campaign that surfaced the right leads based on relevance, demo completion status, and buyer role,
              without overwhelming sellers with raw data they couldn't use. We pushed a huge email campaign that considered the buyer's role and
              business requirements and matched them with seller B2B solutions on the platform that complemented their business requirements.
            </p>
          </div>
        </div>

        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={star} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain", height: "21px" }} />
            </div>

            <h3>Earning trust without overwhelming the user.</h3>
          </div>

          <div class="feature-copy">
            <p>
              For a platform connecting C-suite buyers with B2B software sellers, trust isn't optional —
              <b style={{ textDecoration: "underline" }}>it's the foundation of every interaction.</b> Yet our research found that over a third of new
              users questioned LeadrPro's legitimacy, citing a lack of social proof, unclear messaging, and no visible indicators that the platform
              was credible or established.
            </p>

            <p>
              Beyond visual trust signals, we introduced Leadr Content, a dedicated section housing blogs, podcasts, and webinars curated for B2B
              professionals created by LeadrPro themselves. This gave the platform a voice and a point of view, positioning LeadrPro not just as a
              marketplace, but as a trusted resource in the B2B space. Users who engaged with the content were far more likely to trust the platform
              enough to complete onboarding.
            </p>
          </div>
        </div>
      </section>

      {/* <!-- DEVICE SHOWCASE --> */}
      <section class="device-showcase">
        <div class="device-frame">
          <img src={piece8} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <h2 style={{ margin: "0" }}>Buyer & Seller dashboards</h2>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece20} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece25} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <h2 style={{ margin: "0" }}>Leadr Content hub</h2>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece21} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece22} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece28} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <h2 style={{ margin: "0" }}>Improved onboarding flow</h2>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece23} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece24} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece27} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ objectFit: "contain", height: "636px", position: "relative" }}>
          <img
            src={piece26}
            alt="Jason Azevedo LinkedIn"
            style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "absolute", bottom: "-42px" }}
          />
        </div>
        {/* <div class="device-caption">
          <p>Private space hides itself automatically when it locks.</p>
        </div> */}
      </section>

      {/* <!-- IMPACT --> */}
      <section class="impact-section">
        <div class="impact-content">
          <div class="section-header">
            <h2>Impact: A Platform Users Finally Trust</h2>
          </div>

          <div class="section-content">
            <p>The redesigned LeadrPro experience delivered measurable improvements across all three problem areas identified in research.</p>

            <p>
              A clearer onboarding flow, strategical placed CTA's, large email campaign and restructured information architecture drove approximately{" "}
              <b>600 new users</b> to the platform, with a <b>35%</b>
              conversion rate reflecting how effectively the redesign communicated LeadrPro's value proposition from the first touchpoint.
            </p>

            <p>
              The personalized buyer dashboard and intent-driven product touchpoints increased overall user engagement by <b>50%</b>, confirmed
              through A/B testing, heatmap analysis, and continuous user feedback — proving that closing the gap between buyer and seller intent was
              not just a design goal, but a measurable outcome.
            </p>

            <p>
              The redesign didn't just improve the user experience, it moved the business, contributing to an <b>80%–100%</b> revenue increase that
              validated the investment in clarity, trust, and connection.
            </p>

            {/* <div class="hero-actions">
              <a href="/">
                Google Blog
                <span>↗</span>
              </a>
            </div> */}
          </div>
        </div>

        <div class="impact-mark">
          <img src="/images/mark.svg" alt="" />
        </div>
      </section>
    </div>
  );
}
